{
  "billing": {
    "full": {
      "label": "Full invoice",
      "description": "Only when the agency paid the booking amount to the partner — includes the booking amount + service fee as two lines"
    },
    "feeOnly": {
      "label": "Service fee only",
      "description": "The customer pays the partner directly — the invoice has the service fee only"
    },
    "amountHint": "Required only for a full invoice (when the agency pays the partner)",
    "amountRequired": "Required for a full invoice (the agency paid the partner)",
    "onlyEnabled": "The only mode enabled in settings"
  },
  "list": {
    "title": "Bookings",
    "subtitle": "{{n}} bookings",
    "exportCsv": "Export CSV",
    "newBooking": "New booking",
    "filterByStatus": "Filter by status",
    "all": "All",
    "search": "Search",
    "searchPlaceholder": "Booking ref, confirmation no., customer, phone",
    "coordinator": "Coordinator",
    "allCoordinators": "All coordinators",
    "noCoordinator": "No coordinator",
    "period": "Period",
    "periods": {
      "all": "All time",
      "thisMonth": "This month",
      "lastMonth": "Last month",
      "custom": "Custom range"
    },
    "from": "From",
    "to": "To",
    "caption": "Bookings list",
    "empty": "No matching bookings",
    "clearFilters": "Clear filters",
    "columns": {
      "reference": "Booking ref",
      "customer": "Customer",
      "partner": "Partner",
      "coordinator": "Coordinator",
      "bookingAmount": "Booking amount",
      "fee": "Fee",
      "invoice": "Invoice",
      "status": "Status",
      "date": "Date"
    },
    "mode": {
      "full": "Full",
      "feeOnly": "Fee only"
    }
  },
  "form": {
    "newTitle": "New booking",
    "editTitle": "Edit {{reference}}",
    "cancel": "Cancel",
    "unsavedConfirm": "You have unsaved changes. Discard them?",
    "toast": {
      "saved": "Changes saved",
      "confirmed": "Booking confirmed",
      "draftSaved": "Draft saved"
    },
    "saveFailed": "Couldn't save",
    "errors": {
      "required": "This field is required",
      "chooseCustomer": "Choose a customer",
      "choosePartner": "Choose a partner",
      "feePositive": "The fee must be greater than zero"
    },
    "feeRulePercent": "{{value}}% of the booking amount",
    "partiesPanel": "Booking parties",
    "customer": "Customer",
    "customerPlaceholder": "Search by name or phone",
    "customerSearch": "Customer name or phone number",
    "customerEmpty": "No matching customers",
    "newCustomer": "New customer",
    "partner": "Partner",
    "partnerPlaceholder": "Choose a partner",
    "partnerSearch": "Partner name",
    "partnerEmpty": "No active partners",
    "partnerConfirmation": "Partner confirmation no.",
    "optional": "Optional",
    "notes": "Notes",
    "notesHint": "Optional — not shown to the customer or coordinator",
    "amountsPanel": "Amounts, invoice and coordinator",
    "bookingAmount": "Booking amount (SAR)",
    "feeAmount": "Service fee (SAR)",
    "feeDefault": "Default from settings: {{rule}}",
    "coordinator": "Coordinator",
    "coordinatorAgreement": "{{name}}'s agreement: {{agreement}} of the fee",
    "noAgreement": "This coordinator has no active agreement",
    "directBooking": "Direct booking, no coordinator",
    "none": "None",
    "billingMode": "Invoice mode",
    "summary": {
      "title": "Calculation summary",
      "fee": "Service fee",
      "coordinatorShare": "Coordinator share",
      "coordinatorShareRule": "Coordinator share ({{rule}})",
      "capped": "The fixed share exceeds the fee and has been capped at the fee amount",
      "net": "Agency net"
    },
    "invoice": {
      "title": "Customer invoice",
      "bookingLine": "Booking amount",
      "feeLine": "Service fee",
      "vat": "VAT ({{rate}}%)",
      "total": "Total due from customer",
      "empty": "Enter the amounts to preview the invoice.",
      "note": "The invoice is issued from the booking page after confirmation, and reaches the customer by SMS with a StreamPay payment link."
    },
    "saving": "Saving…",
    "saveChanges": "Save changes",
    "confirm": "Confirm booking",
    "save": "Save",
    "saveDraft": "Save as draft",
    "newCustomerDialog": {
      "title": "New customer",
      "description": "The customer is added and selected for this booking right away."
    }
  },
  "detail": {
    "title": "Booking · {{partner}}",
    "toast": {
      "confirmed": "Booking confirmed",
      "cancelled": "Booking cancelled",
      "invoiceIssued": "Invoice issued, sending to StreamPay"
    },
    "suffix": {
      "paymentFailed": "Payment failed",
      "awaitingPayment": "Awaiting payment"
    },
    "fields": {
      "partner": "Partner",
      "partnerConfirmation": "Partner confirmation no.",
      "createdBy": "Created by"
    },
    "actions": {
      "edit": "Edit",
      "cancelDraft": "Cancel draft",
      "cancelBooking": "Cancel booking",
      "confirm": "Confirm booking",
      "issueInvoice": "Issue invoice"
    },
    "cancelDialog": {
      "title": "Cancel booking {{reference}}?",
      "description": "Bookings are never deleted: it stays in the records as cancelled, and the coordinator's pending commission is voided.",
      "confirm": "Cancel booking"
    },
    "banner": {
      "cancelled": "This booking was cancelled on {{at}}.",
      "refunded": "This booking was fully refunded on {{at}} and the coordinator commission was reversed."
    },
    "detailsPanel": "Booking details",
    "notes": "Notes",
    "customerPanel": "Customer",
    "noEmail": "No email",
    "streampayLinked": "Linked to a StreamPay customer",
    "feesPanel": "Fees and commission",
    "fee": "Service fee",
    "bookingAmount": "Booking amount",
    "noCoordinator": "No coordinator",
    "net": "Agency net",
    "commission": {
      "pending": "The commission is pending and becomes earned when the invoice is paid.",
      "earned": "The commission is earned by the coordinator.",
      "paid": "The commission has been transferred to the coordinator.",
      "reversed": "The commission was reversed due to the refund.",
      "snapshot": "The agreement is stored with the booking as it was at confirmation."
    },
    "eventsPanel": "Activity log",
    "invoice": {
      "toast": {
        "resendCopied": "Payment link copied — share it with the customer (StreamPay can't re-send notifications automatically)",
        "cancelled": "Invoice cancelled",
        "retried": "Retried",
        "linkCopied": "Payment link copied"
      },
      "cancelledTitle": "Invoice {{number}} was cancelled",
      "notIssued": "No invoice issued yet",
      "heading": "Invoice",
      "modeFull": "Full invoice",
      "modeFeeOnly": "Fee only",
      "meta": "{{mode}} · Issued via StreamPay · Due {{due}}",
      "caption": "Invoice lines",
      "columns": {
        "item": "Item",
        "quantity": "Qty",
        "amount": "Amount"
      },
      "vat": "VAT ({{rate}}%)",
      "total": "Total",
      "sending": "Sending to StreamPay…",
      "sendFailed": "Couldn't send the invoice to StreamPay",
      "sendFailedWithError": "Couldn't send the invoice to StreamPay: {{error}}",
      "paymentFailed": "The last payment attempt failed. The invoice is still open and the customer can pay again.",
      "paid": "The invoice was paid on {{at}}.",
      "paymentLink": "Payment link",
      "copyLink": "Copy link",
      "resend": "Resend",
      "cancel": "Cancel invoice",
      "cancelDialog": {
        "title": "Cancel invoice {{number}}?",
        "description": "The customer will no longer be able to pay via the link, and the booking returns to confirmed.",
        "confirm": "Cancel invoice"
      }
    }
  }
}
